<template functional>
  <div
    :ref="data.ref"
    :class="[data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]"
    v-bind="props.attrs"
    v-on="listeners"
  >
    <p class="text">{{ props.attackType }}</p>
    <p class="color" :style="{ backgroundColor: props.bgColor }"></p>
  </div>
</template>

<script>
export default {
  name: 'ColorLegend',
  props: ['attackType', 'bgColor']
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';
div {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin-left: 8px;
  color: white;
  p {
    margin: 0;
    font-size: 0.8em;
  }
  .text {
    color: rgba(0, 0, 0, 0.6);
  }
  .color {
    display: block;
    height: 4px;
    width: 100%;
  }
}

@media (min-width: $phone) and (max-width: $tablet) {
}

@media (min-width: $tablet) and (max-width: $desktop) {
  div {
    p {
      font-size: 1.3em;
    }
    .color {
      height: 8px;
    }
  }
}

@media (min-width: $desktop) {
  div {
    margin-left: 10px;

    p {
      font-size: 1em;
    }
    .color {
      height: 8px;
    }
  }
}
</style>
